function sliderBanner() {
    const swiperContainer = document.querySelector('.banner_swiper-js');
    if (!swiperContainer) return; // le hero APE Store n'utilise qu'une image

    const swiper = new Swiper(swiperContainer, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        autoplay: {
            delay: 3000,
            speed: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.banner_swiper_pagination',
            clickable: true,
        },
        navigation: {
            nextEl: ".banner_next",
            prevEl: ".banner_prev",
        },
    });
}

// Logos de la homepage : défilement continu et infini, 4 logos visibles
function sliderBannerLogos() {
    const swiperContainer = document.querySelector('.banner_logos_swiper-js');
    if (!swiperContainer) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const swiper = new Swiper(swiperContainer, {
        loop: true,
        slidesPerView: 2,
        spaceBetween: 16,
        speed: 3000,
        allowTouchMove: false,
        autoplay: {
            enabled: !reducedMotion, // animations réduites (réglage système) : logos fixes
            delay: 0,
            disableOnInteraction: false,
        },
        breakpoints: {
            576: { slidesPerView: 3 },
            768: { slidesPerView: 4, spaceBetween: 24 },
        },
        a11y: {
            enabled: true,
            slideRole: 'listitem',
            containerRole: null,
            containerMessage: null,
        },
    });

    // Pause au survol, arrêt immédiat (sinon Swiper termine la transition en cours avant de s'arrêter)
    if (reducedMotion) return;

    swiperContainer.addEventListener('mouseenter', () => {
        swiper.autoplay.stop();
        swiper.setTranslate(swiper.getTranslate());
    });

    swiperContainer.addEventListener('mouseleave', () => {
        swiper.autoplay.start();
    });
}

document.addEventListener('DOMContentLoaded', function () {
    sliderBanner();
    sliderBannerLogos();
});